import * as React from "react";
import { Box, Container, Typography, useMediaQuery } from "@mui/material";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import { EconomicImpactIntroduction } from "../Statistics/EconomicImpatcIntroduction/EconomicImpactIntroduction";
import { SelectButtons } from "../Statistics/SelectButtons/SelectButtons";
import theme from "../../../components/styles/theme/theme";
import { isRegion } from "../../../config";

export const StickyContent: React.FC = () => {
  const isLgScreen = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: (theme) => theme.palette.common.white,
      }}
      className="hidden-print"
    >
      <Container maxWidth={"xl"}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: `${isLgScreen ? "column" : "row"}`,
            gap: `${isLgScreen ? "20px" : "0"}`,
            padding: "0 25px",
          }}
        >
          <EconomicImpactIntroduction />
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
            <SelectButtons />
            {isRegion.usa && (
              <Box sx={{ display: "flex", alignItems: "center", alignSelf: "flex-start", gap: "4px", mt: 0.5, ml: 1.7
              }}>
                <FmdGoodIcon sx={{ fontSize: 16, color: theme.palette.common.black }} />
                <Typography
                  variant="body1"
                  color={theme.palette.component["900"]}
                >
                  Production facility
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
